import { Component, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { AbinResultDto } from 'src/app/inge-api/abinclient/models';
import { Store, select } from '@ngrx/store';
import { InGeApiState } from 'src/app/store/state-model/inge-api.model';

@Component({
    selector: 'app-arsskador-gran-sammanvagning',
    templateUrl: './arsskador-gran-sammanvagning.component.html',
    styleUrls: ['./arsskador-gran-sammanvagning.component.scss']
})
export class ArsskadorGranSammanvagningComponent implements OnInit {
    inventering$: Observable<AbinResultDto>;
    loadingInventeringar$: Observable<boolean>;
    inventeringarError$: Observable<boolean>;
    private subs: Subscription[];
    constructor(private store: Store<InGeApiState>) {
        this.inventering$ = this.store.pipe(
            select((x) => {
                if (x && x.abin.inventeringar && x.abin.inventeringar.length > 0) {
                    return x.abin.inventeringar[0];
                }
            })
        );
        this.loadingInventeringar$ = store.pipe(select((x) => x.abin.loadingInventeringar));
        this.inventeringarError$ = store.pipe(select((x) => x.abin.inventeringarError));
    }

    ngOnInit(): void {}
}
